export default __webpack_public_path__ + "static/media/automation(1).2e329720.png";